export class NotificationDto {
  id: string; // random uuid
  type: string; // e.g. payment_overdue
  comment: string;
  values: { [key: string]: string }; // contains values which are specific to the type of notification
  dateCreated: string;
  status: string; // "new" or "read"
  userId: string;
  userIdStatus: string; // e.g. abcd-new, used for indexing
  styleInfo: string; // "warning" or "info"

  constructor(data: Partial<NotificationDto>) {
    // Initialize the class from the provided data or defaults
    this.id = data.id ?? '';
    this.type = data.type ?? '';
    this.comment = data.comment ?? '';
    this.values = data.values ?? {};
    this.dateCreated = data.dateCreated ?? '';
    this.status = data.status ?? '';
    this.userId = data.userId ?? '';
    this.userIdStatus = data.userIdStatus ?? '';
    this.styleInfo = data.styleInfo ?? '';
  }
}
